import React, { useState } from 'react';
import format from 'date-fns/format';
import enUS from 'date-fns/locale/en-US';
import fr from 'date-fns/locale/fr';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import HelpIcon from '@mui/icons-material/Help';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import Button from '@mui/material/Button';
import styles from '@/pages/task-list/styles.less';
import { useToggle } from '@/common/hooks/index';
import {
  DecedentInfoOverlay,
  UserGuide,
} from '@/common/containers/Modals/index';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [modal, toggleModal] = useToggle(false);
  const [overview, setOverview] = useState('');

  return (
    <>
      <UserGuide mode={overview} onModeChange={setOverview} />
      <DecedentInfoOverlay open={modal} onClose={toggleModal} />
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderIconLabel}>
          <CalendarTodayIcon />
          <span>
            {format(new Date(), 'dd MMM yyyy', {
              locale: i18n.language === 'fr' ? fr : enUS,
            })}
          </span>
        </div>
        <div className={styles.pageHeaderBtnGroup}>
          <Button
            onClick={toggleModal}
            variant="outlined"
            color="success"
            startIcon={<StickyNote2Icon />}
          >
            {t('Decedent info')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default Header;
